// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useMemo } from 'react';
import { SendBox, SendBoxStylesProps } from '@internal/react-components';
import { usePropsFor } from '../ChatComposite/hooks/usePropsFor';
/**
 * @private
 */
export type SendBoxPickerProps = {
  styles?: SendBoxStylesProps;
  autoFocus?: 'sendBoxTextField';
  onSendMessage: (content: string) => Promise<void>;
};

/**
 * @private
 */
export const SendBoxPicker = (props: SendBoxPickerProps): JSX.Element => {
  const sendBox = useMemo(() => <SendBoxWrapper {...props} />, [props]);
  return sendBox;
};

// Move SendBox initialization to a separate component as otherwise it will cause re-render for Suspense and _ErrorBoundary when props and sendBoxProps are updated
const SendBoxWrapper = (props: SendBoxPickerProps): JSX.Element => {
  const sendBoxProps = usePropsFor(SendBox);
  return <SendBox {...sendBoxProps} {...props} />;
};